import { useContext } from 'react'

import Field from '@ors/components/manage/Form/Field'
import { getFilterOptions } from '@ors/components/manage/Utils/utilFunctions'
import PermissionsContext from '@ors/contexts/PermissionsContext'
import PopoverInput from '../../Replenishment/StatusOfTheFund/editDialogs/PopoverInput'
import { SearchFilter } from '../HelperComponents'
import { tableColumns } from '../constants'

import { IoChevronDown } from 'react-icons/io5'
import { union } from 'lodash'

const ProjectsFilters = ({
  mode,
  filterOptions = {},
  form,
  filters,
  handleFilterChange,
  handleParamsChange,
}: any) => {
  const { canViewMetainfoProjects, canViewSectorsSubsectors, isMlfsUser } =
    useContext(PermissionsContext)

  const meetingsOptions = filterOptions?.meeting
    ? [...filterOptions.meeting].reverse()
    : []

  const defaultProps = {
    multiple: true,
    value: [],
    getOptionLabel: (option: any) => option?.name,
    FieldProps: { className: 'mb-0 w-full md:w-[7.76rem] BPList' },
    popupIcon: <IoChevronDown size="18" color="#2F2F38" />,
    componentsProps: {
      popupIndicator: {
        sx: {
          transform: 'none !important',
        },
      },
    },
  }

  return (
    <div className="grid h-full grid-cols-2 flex-wrap items-center gap-x-2 gap-y-2 border-0 border-solid md:flex">
      <SearchFilter
        placeholder="Search by keyword..."
        {...{ form, filters, handleFilterChange, handleParamsChange }}
      />
      {mode === 'listing' && (
        <Field
          Input={{ placeholder: tableColumns.country }}
          options={getFilterOptions(
            filters,
            filterOptions?.country,
            'country_id',
          )}
          widget="autocomplete"
          onChange={(_: any, value: any) => {
            const country = filters.country_id || []
            const newValue = union(country, value)

            handleFilterChange({ country_id: newValue })
            handleParamsChange({
              country_id: newValue.map((item: any) => item.id).join(','),
              offset: 0,
            })
          }}
          {...defaultProps}
        />
      )}
      <Field
        Input={{ placeholder: tableColumns.agency }}
        options={getFilterOptions(filters, filterOptions?.agency, 'agency_id')}
        widget="autocomplete"
        onChange={(_: any, value: any) => {
          const agency = filters.agency_id || []
          const newValue = union(agency, value)

          handleFilterChange({ agency_id: newValue })
          handleParamsChange({
            agency_id: newValue.map((item: any) => item.id).join(','),
            offset: 0,
          })
        }}
        {...defaultProps}
      />
      {canViewMetainfoProjects && (
        <>
          <Field
            Input={{ placeholder: tableColumns.cluster }}
            options={getFilterOptions(
              filters,
              filterOptions?.cluster,
              'cluster_id',
            )}
            widget="autocomplete"
            onChange={(_: any, value: any) => {
              const projectCluster = filters.cluster_id || []
              const newValue = union(projectCluster, value)

              handleFilterChange({ cluster_id: newValue })
              handleParamsChange({
                offset: 0,
                cluster_id: newValue.map((item: any) => item.id).join(','),
              })
            }}
            {...defaultProps}
          />
          <Field
            Input={{ placeholder: tableColumns.type }}
            options={getFilterOptions(
              filters,
              filterOptions?.project_type,
              'project_type_id',
            )}
            widget="autocomplete"
            onChange={(_: any, value: any) => {
              const projectType = filters.project_type_id || []
              const newValue = union(projectType, value)

              handleFilterChange({ project_type_id: newValue })
              handleParamsChange({
                offset: 0,
                project_type_id: newValue.map((item: any) => item.id).join(','),
              })
            }}
            {...defaultProps}
          />
        </>
      )}
      {canViewSectorsSubsectors && (
        <Field
          Input={{ placeholder: tableColumns.sector }}
          options={getFilterOptions(
            filters,
            filterOptions?.sector,
            'sector_id',
          )}
          widget="autocomplete"
          onChange={(_: any, value: any) => {
            const sector = filters.sector_id || []
            const newValue = union(sector, value)

            handleFilterChange({ sector_id: newValue })
            handleParamsChange({
              offset: 0,
              sector_id: newValue.map((item: any) => item.id).join(','),
            })
          }}
          {...defaultProps}
        />
      )}
      <div className="w-full md:w-[7.76rem]">
        <PopoverInput
          className="!m-0 h-[2.25rem] min-h-[2.25rem] truncate border-2 !pr-0 !text-[16px] text-inherit"
          label="Meeting"
          options={meetingsOptions}
          onChange={(value: any) => {
            const meetingId = filters.meeting_id || []
            const meetingValue = meetingsOptions.filter(
              (meeting: any) => meeting.value === value,
            )
            const newValue = union(meetingId, meetingValue)

            handleFilterChange({ meeting_id: newValue })
            handleParamsChange({
              offset: 0,
              meeting_id: newValue.map((item: any) => item.value).join(','),
            })
          }}
        />
      </div>
      {canViewMetainfoProjects && (
        <>
          {mode === 'listing' && (
            <Field
              Input={{ placeholder: tableColumns.submission_status }}
              options={getFilterOptions(
                filters,
                filterOptions?.submission_status,
                'submission_status_id',
              )}
              widget="autocomplete"
              onChange={(_: any, value: any) => {
                const submissionStatus = filters.submission_status_id || []
                const newValue = union(submissionStatus, value)

                handleFilterChange({ submission_status_id: newValue })
                handleParamsChange({
                  submission_status_id: newValue
                    .map((item: any) => item.id)
                    .join(','),
                  offset: 0,
                })
              }}
              {...defaultProps}
              FieldProps={{ className: 'mb-0 w-full md:w-[10.5rem] BPList' }}
            />
          )}
          <Field
            Input={{ placeholder: tableColumns.project_status }}
            options={getFilterOptions(
              filters,
              filterOptions?.status,
              'status_id',
            )}
            widget="autocomplete"
            onChange={(_: any, value: any) => {
              const projectStatus = filters.status_id || []
              const newValue = union(projectStatus, value)

              handleFilterChange({ status_id: newValue })
              handleParamsChange({
                offset: 0,
                status_id: newValue.map((item: any) => item.id).join(','),
              })
            }}
            {...defaultProps}
            FieldProps={{
              className: defaultProps.FieldProps.className + ' md:w-[9rem]',
            }}
          />
        </>
      )}
      {isMlfsUser && (
        <Field
          Input={{
            placeholder: tableColumns.blanket_or_individual_consideration,
          }}
          options={getFilterOptions(
            filters,
            filterOptions?.blanket_approval_individual_consideration,
            'blanket_or_individual_consideration',
          )}
          widget="autocomplete"
          onChange={(_: any, value: any) => {
            const consideration =
              filters.blanket_or_individual_consideration || []
            const newValue = union(consideration, value)

            handleFilterChange({
              blanket_or_individual_consideration: newValue,
            })
            handleParamsChange({
              blanket_or_individual_consideration: newValue
                .map((item: any) => item.id)
                .join(','),
              offset: 0,
            })
          }}
          {...defaultProps}
          FieldProps={{
            className: defaultProps.FieldProps.className + ' md:!w-[21rem]',
          }}
        />
      )}
    </div>
  )
}

export default ProjectsFilters
